import {
  Paper,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  CustomTableRowTR,
  StyledTable,
  TableData,
  TableHeader,
  TableTopHeader,
  TableWrapper,
  Title,
} from "../../styles/commonStyles";

const ChefForPartyPaymentStatusCard = ({ record }: { record: any }) => {
  const shouldShowPartialPaymentStatus = record?.partialPayment != null;
  const rows = [
    {
      label: "Token Amount Status",
      value: record?.tokenAmountPaymentStatus || "-",
    },
    {
      label: "Remaining Amount Status",
      value: record?.remainingAmountPaymentStatus || "-",
    },
    ...(shouldShowPartialPaymentStatus
      ? [
          {
            label: "Partial Payment Status",
            value: record?.partialPaymentStatus || "-",
          },
        ]
      : []),
    ...(record?.isCashCollected === true
      ? [
          {
            label: "Cash Collected",
            value: "Yes",
          },
        ]
      : []),
  ];

  return (
    <TableWrapper>
      <TableTopHeader>
        <Title>Payment Status</Title>
      </TableTopHeader>

      <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
        <StyledTable>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "rgba(232, 235, 237, 0.3) !important",
              }}
            >
              <TableHeader>Field</TableHeader>
              <TableHeader>Value</TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <CustomTableRowTR key={row.label}>
                <TableData>{row.label}</TableData>
                <TableData>{row.value}</TableData>
              </CustomTableRowTR>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </TableWrapper>
  );
};

export default ChefForPartyPaymentStatusCard;
